import * as d3 from 'd3'
export default {
  
  methods: {

    tbl_SubSystem(sys, desc) {
      
      d3.select(`#NO_SUBSYS`).text(sys)
      d3.select(`#DESC_SUBSYS`)
      .attr('x', this.getNode(`#TITLE_SUBSYS`)+this.getNode(`#NO_SUBSYS`)+10)
      .text(`(${desc})`)

      let dataSet  = this.subSysData.filter(f=> f.SYS == sys)
      let sumTotal = {}

      this.system.cols.filter(f=> f.dps==2).forEach(col=> {
        sumTotal[col.code] = dataSet.map(d => d[col.code]).reduce((a, b) => (a + b))
      })
      sumTotal.SYS = dataSet[0].SYS


      this.subSysCanvas = this.canvasForm
      .append('g')
      .attr('transform', `translate(${this.subsys.x}, ${this.subsys.y})`)

      let y_ = 45
      dataSet.forEach((d,i)=> {

        this.gmx_Line(this.subSysCanvas, 0, this.subsys.width, y_+5, y_+5, (i==dataSet.length-1) ? '#bcbcbc' : '#E0E0DF', .5, 3)

        let sys = this.subSysCanvas
        .append('g')
        .attr('transform', `translate(0, ${y_})`)

        sys
        .append('text')
        .attr('x', this.system.cols[0].tx).attr('y',  0)
        .attr('font-size', 10).attr('fill', '#757575').attr('text-anchor', this.subsys.cols[0].align)
        .text(i+1)

        this.subsys.cols.forEach((col,c)=> {
          if(c==0) return
          sys
          .append('text')
          .attr('x', col.tx).attr('y',  0)
          .attr('font-size', 10).attr('fill', '#333').attr('text-anchor', col.align)
          .text(typeof d[col.code] === 'string' && d[col.code].length > 50 ? d[col.code].substr(0,40) + '...' : d[col.code])
          .call(this.event_Link, d , col)
        })

        y_ += this.subsys.lineHeight
      })
      
      // TOTAL
      this.subSysCanvas
      .append('text')
      .attr('x', this.subsys.cols[2].ex/2).attr('y',  y_)
      .attr('font-size', 10).attr('fill', '#333').attr('text-anchor', 'middle')
      .text('TOTAL')

      this.subsys.cols.filter(f=> f.dps==2).forEach(col=> {
        this.subSysCanvas
        .append('text')
        .attr('id', `SUBSYS_TOTAL`)
        .attr('x', col.tx).attr('y',  y_)
        .attr('font-size', 10).attr('fill', '#333').attr('text-anchor', col.align)
        .text(sumTotal[col.code])
        .call(this.event_Link, sumTotal , col, 'KEY1')
      })

      this.gmx_Line(this.subSysCanvas, 0, this.subsys.width, y_+5, y_+5, '#bcbcbc', .5, 3)
      
    },

  }
}